import { render } from "./CouponMemberCenter.vue?vue&type=template&id=2609ea43&ts=true"
import script from "./CouponMemberCenter.vue?vue&type=script&lang=ts"
export * from "./CouponMemberCenter.vue?vue&type=script&lang=ts"

import "./CouponMemberCenter.vue?vue&type=style&index=0&id=2609ea43&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])